import React, { useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import io from "../Components/socket";
import Socket from "./../Components/socket";

const Refer = ({ user }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data.superUser);
    });
  }, [Socket]);

  useEffect(() => {
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);
  }, []);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Kingtox  पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है।
  दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 2% कमीशन दिया जाएगा  
  
    100% भरोसेमंद प्लेटफार्म। 24 hours support https://kingtox.in/login/${user.referral_code}
  
  Your ReferralCode is - ${user.referral_code}.`;

  return (
    <>
      {/* <Header user={user} /> */}
      <div>
        <div
          className="leftContainer mt-4 pb-5"
          style={{ minHeight: "", height: "100%" }}
        >
          <section className="refer-dashboard">
            {/* Top Section: Header */}
            <div className="refer-header-premium">
              <h2 className="premium-title">Invite & Earn</h2>
              <p className="premium-subtitle">
                Share your code and get 3% of your friend's winnings!
              </p>
            </div>

            {/* Referral Code Card */}
            <div className="refer-card-main">
              <label className="input-label">Your Unique Referral Code</label>
              <div className="refer-code-wrapper">
                <div className="code-display">
                  <span>{user.referral_code}</span>
                </div>
                <button
                  className="copy-action-btn"
                  onClick={(e) => copyCode(e)}
                >
                  <i className="far fa-copy"></i> Copy
                </button>
              </div>
            </div>
            <div className="whatsapp_share_btn">
              <a
                href={`whatsapp://send?text=Hi%20Friends%2C%20Play%20kingtox%20%20and%20earn%2010000%20daily.%20Download%20Indian%20App%20kingtox%0A%0A%20%20kingtox%20%E0%A4%AA%E0%A4%B0%20%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%E0%A4%A8%E0%A5%87%20%E0%A4%AA%E0%A4%B0%20%E0%A4%89%E0%A4%A8%E0%A4%95%E0%A4%BE%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%20%E0%A4%B2%E0%A4%BE%E0%A4%87%E0%A4%AB%20%E0%A4%9F%E0%A4%BE%E0%A4%87%E0%A4%AE%202%25%20%E0%A4%95%E0%A4%AE%E0%A5%80%E0%A4%B6%E0%A4%A8%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%8F%E0%A4%97%E0%A4%BE%20%20%0A%0A%20%20100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%E0%A5%A4%2024%20hours%20support%20https%3A%2F%2Fkingtox.in%2Flogin%2F${user.referral_code}%0A%20%20%0A%20%20Your%20ReferralCode%C2%A0is%C2%A0${user.referral_code}.`}
              >
                <BsWhatsapp className="icons mr-1" />
                WhatsApp
              </a>
            </div>
            <div className="divider-container">
              <span className="divider-line"></span>
              <span className="divider-text">Your Stats</span>
              <span className="divider-line"></span>
            </div>

            {/* Stats Grid */}
            <div className="stats-grid">
              <div className="stat-box box-blue">
                <div className="stat-info">
                  <h3>{user.referral_user?.length || 0}</h3>
                  <p>Total Players</p>
                </div>
                <div className="stat-icon-bg">
                  <img src="./trophy.png" alt="trophy" />
                </div>
              </div>

              {open && (
                <div className="stat-box box-gold">
                  <div className="stat-info">
                    <h3>₹ {user.referral_earning}</h3>
                    <p>Total Earnings</p>
                  </div>
                  <div className="stat-icon-bg">
                    <img src="./indian-rupee-money-bag.png" alt="earnings" />
                  </div>
                </div>
              )}
            </div>

            {/* How It Works Section */}
            <div className="info-card-modern">
              <div className="info-header">
                <i className="fas fa-info-circle"></i>
                <h4>How It Works</h4>
              </div>
              <div className="step-list">
                <div className="step-item">
                  <div className="step-number">01</div>
                  <p>
                    You can refer and <strong>Earn 3%</strong> of your referral
                    winning, every time.
                  </p>
                </div>
                <div className="step-item">
                  <div className="step-number">02</div>
                  <p>
                    If your player wins <strong>₹10,000</strong>, you instantly
                    get <strong>₹300</strong> in your wallet.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
